<template>
  <div class="my-0 pt-0">
    <div class="card card-custom gutter-b rounded mt-0 pt-0">
      <!--    <div class="card-body">-->
      <v-carousel
          cycle
          height="auto"
          hide-delimiter-background
          show-arrows-on-hover
          vertical
          :show-arrows="false"
          vertical-delimiters="vertical"
      >
        <v-carousel-item v-for="slide in banners" :key="slide.id" :src="slide.picture" style="max-height: 300px"></v-carousel-item>
      </v-carousel>
      <!--    </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardBaner",
  data() {
    return {
      banners: [],
    }
  },
  mounted() {
    this.getBanner()
  },

  methods: {
    getBanner() {
      this.requestApiGet('/user/content?length=3&type=banner')
          .then(({data})=>{
            this.banners = data.data;
          })
    }
  }
}
</script>

<style scoped>

</style>